module.exports = __webpack_public_path__ + "static/img/tobpic10.37c6647d.png";